import React from 'react'
import { HiMagnifyingGlass, HiXMark } from 'react-icons/hi2'
import { Button } from './Button'
import { cn } from './cn'

export function SearchField({
  value,
  onChange,
  onSubmit,
  onClear,
  placeholder = 'Search…',
  className,
}) {
  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit?.(e)
  }

  return (
    <form onSubmit={handleSubmit} className={cn('flex flex-wrap items-center gap-2', className)}>
      <div className="relative min-w-[200px] flex-1">
        <HiMagnifyingGlass className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-text-muted" />
        <input
          type="search"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className="input-field pl-9"
        />
      </div>
      <Button type="submit" variant="secondary" size="sm">Search</Button>
      {onClear && value && (
        <Button type="button" variant="ghost" size="sm" onClick={onClear} aria-label="Clear search">
          <HiXMark className="h-4 w-4" />
        </Button>
      )}
    </form>
  )
}
